module.exports = __webpack_public_path__ + "./favicons/ms-icon-70x70.png";